import * as types from "../types/printRequests"

export const addPrintRequest = (newPrintRequest) => ({
  type: types.ADD_PRINT_REQUEST,
  newPrintRequest
})

export const deletePrintRequest = (printRequestId) => ({
  type: types.DELETE_PRINT_REQUEST,
  printRequestId
})